export default {
  JP: {
    fullDate: 'YYYY/MM/DD (dddd)',
    shortDate: 'M/D',
    time: 'HH:mm',
  },
  DEFAULT: {
    fullDate: 'dddd, MMMM D',
    shortDate: 'MMM D',
    time: 'hA',
  },
};
